/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_len_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why is a mile such an odd number of meters (1609.344)?`)
};

const es_uc_len_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué una milla es un número tan extraño de metros (1609.344)?`)
};

const de_uc_len_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum ergibt eine Meile eine so unrunde Anzahl Meter (1609.344)?`)
};

const nl_uc_len_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom is een mijl zo'n vreemd getal meter (1609,344)?`)
};

const fr_uc_len_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi un mile est-il un nombre aussi curieux de mètres (1609,344) ?`)
};

const it_uc_len_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché un miglio è un numero così strano di metri (1609.344)?`)
};

const pt_br2_uc_len_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que uma milha tem um número tão estranho de metros (1609.344)?`)
};

const pt_uc_len_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é uma milha um número tão estranho de metros (1609,344)?`)
};

const ja_uc_len_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイルがメートルで奇数(1609.344)なのはなぜですか?`)
};

const zh_uc_len_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_len_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_len_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_len_faq2_q", locale)
	if (locale === "en") return en_uc_len_faq2_q(inputs)
	if (locale === "es") return es_uc_len_faq2_q(inputs)
	if (locale === "de") return de_uc_len_faq2_q(inputs)
	if (locale === "nl") return nl_uc_len_faq2_q(inputs)
	if (locale === "fr") return fr_uc_len_faq2_q(inputs)
	if (locale === "it") return it_uc_len_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_len_faq2_q(inputs)
	if (locale === "pt") return pt_uc_len_faq2_q(inputs)
	if (locale === "ja") return ja_uc_len_faq2_q(inputs)
	return zh_uc_len_faq2_q(inputs)
};